export default {
	namespaced: true,
	state: {
		jsonArrayMaterial: [],
		activeMaterial: ""
	},
	mutations: {
		cambioArrayMaterial(state, payload) {
			state.jsonArrayMaterial = payload;
		},
		activeMaterial(state, payload) {
			state.activeMaterial = payload;
		},
		changeCajaTexto(state,payload){
			state.activeMaterial.cajaTexto = payload;
		}, 
		updateMaterial(state, payload) {
			state.jsonArrayMaterial = state.jsonArrayMaterial.map(
        material => (material.idBiblioteca === payload.idBiblioteca)
          ? {...payload}
          : {...material}
			);
    },
    setMaterial(state,payload){
      state.jsonArrayMaterial.push(payload);
    }
	},
	actions: {
		updateArrayMaterial({ commit }, payload) {
			commit("cambioArrayMaterial", payload);
		},
		activeMaterial({ commit }, payload) {
			commit("activeMaterial", payload);
		},
		changeCajaTexto({commit},payload){
			commit('changeCajaTexto',payload)
		},
		updateMaterial({ commit }, payload) {
			commit("updateMaterial", payload);
    },
    setMaterial({commit},payload){
      commit('setMaterial',payload)
    }
	},
	getters: {}
};